const config = {
  env: process.env.NODE_ENV,
  publicUrl: process.env.PUBLIC_URL,
  apiUrl: process.env.REACT_APP_API_URL,
  apiUrl1: process.env.REACT_APP_API_URL_1,
  apiUrl2: process.env.REACT_APP_API_URL_2,
  oauthClientId: process.env.REACT_APP_OAUTH_CLIENT_ID,
  oauthClientSecret: process.env.REACT_APP_OAUTH_CLIENT_SECRET,
  oauthAudience: process.env.REACT_APP_OAUTH_AUDIENCE,
};

export default config;
